// extracted by mini-css-extract-plugin
export default {"drawer":"drawer__drawer"};